import { render, staticRenderFns } from "./DWSBaseSyncView.vue?vue&type=template&id=e681e2b4&scoped=true&"
import script from "./DWSBaseSyncView.vue?vue&type=script&lang=ts&"
export * from "./DWSBaseSyncView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e681e2b4",
  null
  
)

export default component.exports